import React from 'react';
import { LockIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function TrustBar() {
  const trustItems = [{
    title: 'Pagamento Sicuro',
    desc: 'Crittografia SSL 256-bit'
  }, {
    title: 'Garanzia 100%',
    desc: '45 giorni di prova'
  }, {
    title: 'Accesso Immediato',
    desc: 'Download istantaneo'
  }, {
    title: 'Privacy Protetta',
    desc: 'Dati personali al sicuro'
  }, {
    title: 'Supporto Dedicato',
    desc: 'Assistenza via email'
  }];
  return <section className="bg-white border-y border-gray-200 py-12 px-4" data-id="element-294">
      <div className="max-w-6xl mx-auto" data-id="element-295">
        <div className="text-center mb-10" data-id="element-296">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-297">
            <LockIcon className="w-6 h-6 text-green-600" data-id="element-298" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-299">
              Transazione Sicura al 100%
            </h2>
          </div>
          <p className="text-gray-600" data-id="element-300">
            Il tuo acquisto è protetto e i tuoi dati sono al sicuro.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-10" data-id="element-301">
          {trustItems.map((item, i) => <div key={i} className="text-center" data-id="element-302">
              <p className="font-bold text-gray-900 text-sm mb-1" data-id="element-303">
                {item.title}
              </p>
              <p className="text-xs text-gray-500" data-id="element-304">{item.desc}</p>
            </div>)}
        </div>

        <div className="border-t border-gray-100 pt-8 flex justify-center" data-id="element-305">
          <PaymentBadges data-id="element-306" />
        </div>
      </div>
    </section>;
}